module.exports = __webpack_public_path__ + "img/reveal_closed.62418219.svg";